import { useState } from 'react';

import { Input, Dropdown } from '../../components';
import { Button, SubmitButton } from '../../components';
import { Modal, Form, FormItem } from '../../components';
import type { FormType } from './useCampaignActions';

type CampaignModalProps = {
  loading: boolean;
  initialValues?: FormType;

  onClose: () => void;
  onSumbit: (payload: FormType) => void;
};

const CampaignModal: React.FC<CampaignModalProps> = ({
  loading,
  initialValues,
  onClose,
  onSumbit,
}) => {
  const [values, setValues] = useState<FormType>(
    initialValues || { status: 'active' }
  );

  return (
    <Form<FormType> initialValue={values} onChange={setValues}>
      <Modal
        open
        title={initialValues ? 'Edit Campaign' : 'Add Campaign'}
        onClose={onClose}
        bottomActions={
          <>
            <SubmitButton
              type="primary"
              loading={loading}
              onClick={() => values && onSumbit?.(values)}
            >
              Save
            </SubmitButton>
            <Button onClick={onClose}>Cancel</Button>
          </>
        }
      >
        <div className="flex flex-col gap-y-md">
          <FormItem<FormType> label="Name" name="name" required>
            <Input />
          </FormItem>
          <FormItem<FormType> label="Description" name="description" required>
            <Input />
          </FormItem>
          <FormItem<FormType> label="Status" name="status" required>
            <Dropdown
              options={[
                { value: 'active', label: 'Active' },
                { value: 'inactive', label: 'Inactive' },
                { value: 'completed', label: 'Completed' },
              ]}
            />
          </FormItem>

          <FormItem<FormType>
            required
            label="Outbound Phone Id"
            name="outbound_phone_id"
          >
            <Input />
          </FormItem>
          <FormItem<FormType>
            required
            name="default_agent_id"
            label="Default Agent Id"
          >
            <Input />
          </FormItem>
        </div>
      </Modal>
    </Form>
  );
};

export default CampaignModal;
